import React from 'react';
import { connect } from 'react-redux';
import InternationalShippingModal, {
    internationalShippingModalId
} from 'tradera-components/international-shipping-modal/international-shipping-modal';
import {
    SyiZignSecModal,
    syiZignSecModalId
} from 'tradera-apps/syi/script/app_react/pages/summary-page/components/syi-zign-sec-modal';

const ModalRenderer = props => (
    <div>
        {
            {
                [internationalShippingModalId]: <InternationalShippingModal />,
                [syiZignSecModalId]: <SyiZignSecModal />
            }[props.currentModal]
        }
    </div>
);

export default connect(state => state.ui.modals)(ModalRenderer);

export { ModalRenderer };
